export default __webpack_public_path__ + "static/media/5.3effc9f2.png";